import { MobileDriver } from '../driver';
import { CanvasOpMobileMock, FlagsMobileMock } from '@fullstory/mobile-flatbuffers';
import { CanvasRendererFactory } from '../canvasrender';
import { View, CanvasMobileMock, Frame } from '../view';
import { PageTypeEnum } from '@fullstory/client-api';
import { MobileMockCanvasRendererFactory } from './mobilemockcanvasrender';
import { CanvasDecoder } from '../canvasdecoder';

export class MobileMockDriver extends MobileDriver<CanvasOpMobileMock> {
  private _factory: CanvasRendererFactory<CanvasOpMobileMock>;

  constructor() {
    super();
    this._factory = new MobileMockCanvasRendererFactory();
  }

  type = PageTypeEnum.PageTypeMobileMock;
  defaultCanvasDefintion = new Int8Array();
  isBlockedFlag = FlagsMobileMock.BLOCKED;
  isWebViewFlag = FlagsMobileMock.WEBVIEW;

  rendererFactory(): CanvasRendererFactory<CanvasOpMobileMock> {
    return this._factory;
  }

  reprocessCanvas(view: View) {}

  unpackCanvas(frame: Frame, decoder: CanvasDecoder): CanvasMobileMock[] {
    // Custom unpack for mobile mock
    return [];
  }

  unpackCanvasItem(canvasJson: any) {
    return null;
  }
}
